import { createFileRoute } from "@tanstack/react-router";
import EventAttendees from "@/components/protected/event-attendees/EventAttendees";

export const Route = createFileRoute("/_protected/admin/attendees")({
  component: EventAttendees,
});
